// src/components/guardianConfirmation.js

const GuardianConfirmation = ({ requestInfo }) => {
  const processConfirmationContent = () => {
    // Safely extract the needed data using optional chaining (?.)
    const rawHtml = requestInfo?.agreement_version?.content;
    const childName = requestInfo?.action_data?.child_name;
    const childDob = requestInfo?.action_data?.child_dob;

    // If essential data is missing, return a helpful message.
    if (!rawHtml || !childName || !childDob) {
      return '<p>There was an issue loading the confirmation details. Please try again.</p>';
    }

    // Replace placeholders with the actual data.
    // The 'g' flag ensures all instances are replaced.
    const processedHtml = rawHtml
      .replace(/{child_name}/g, `<strong>${childName}</strong>`)
      .replace(/{child_dob}/g, `<strong>${childDob}</strong>`);

    return processedHtml;
  };
  
  // Get the processed HTML to render.
  const finalHtmlContent = processConfirmationContent();

  return (
    <div className="guardian-confirmation-content">
      <h2>{requestInfo?.title || 'Guardian Confirmation'}</h2>
      
      <div dangerouslySetInnerHTML={{ __html: finalHtmlContent }} />
    </div>
  );
};

export default GuardianConfirmation;